import {
  DRIFT_CHAT_APP_USERS_DIMENSIONS,
  DRIFT_CHAT_END_USERS_DIMENSIONS,
  DRIFT_CHAT_INTERACTIONS_DIMENSIONS,
  MEETINGS_USERS_DIMENSIONS,
  PLAYBOOK_OUTCOMES_DIMENSIONS,
} from 'cube/constants'

import { CubeQuery } from '@driftt/dds.reports'

export const PlaybookFastlaneChatQuery: CubeQuery = {
  name: 'PlaybookFastlaneChat',
  queryName: 'PlaybookFastlaneChat',
  query: {
    dimensions: [
      DRIFT_CHAT_APP_USERS_DIMENSIONS.NAME,
      DRIFT_CHAT_END_USERS_DIMENSIONS.DISPLAY_NAME,
      DRIFT_CHAT_END_USERS_DIMENSIONS.EMAIL,
      MEETINGS_USERS_DIMENSIONS.END_USER_AVATAR_URL,
      DRIFT_CHAT_INTERACTIONS_DIMENSIONS.MESSAGE_BODY,
      MEETINGS_USERS_DIMENSIONS.END_USER_COMPANY_NAME,
      PLAYBOOK_OUTCOMES_DIMENSIONS.HAS_CONVERSATION_HELD,
      PLAYBOOK_OUTCOMES_DIMENSIONS.CONVERSATION_ID,
      PLAYBOOK_OUTCOMES_DIMENSIONS.END_USER_ID,
      PLAYBOOK_OUTCOMES_DIMENSIONS.OUTCOME_EVENT_TYPE,
      PLAYBOOK_OUTCOMES_DIMENSIONS.HAS_MEETING_BOOKED,
      MEETINGS_USERS_DIMENSIONS.END_USER_COMPANY_EMPLOYMENT_TITLE,
      PLAYBOOK_OUTCOMES_DIMENSIONS.OUTCOME_UPDATED_AT,
    ],
  },
}
